// client/src/components/game_hud/EnergyBar.jsx
// Итерация 5: полоска энергии с зоной усталости.
// Дизайн C: перекрытие — синяя (энергия) + серая (усталость) + текст-процент.

import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { Bolt as BoltIcon } from '@mui/icons-material';

const EnergyBar = ({ current = 100, max = 100, fatigue = 0, isStale = false }) => {
  const safeMax = max > 0 ? max : 100;
  const safeCurrent = Math.max(0, Math.min(current, safeMax));
  const safeFatigue = Math.max(0, Math.min(fatigue, safeMax));

  const currentPct = (safeCurrent / safeMax) * 100;
  // Усталость в процентах от max (не закрывает current — это отдельная зона «потенциал»)
  const fatiguePct = (safeFatigue / safeMax) * 100;

  const getEnergyColor = () => {
    if (currentPct > 70) return '#3b82f6';
    if (currentPct > 40) return '#0ea5e9';
    if (currentPct > 20) return '#eab308';
    return '#f97316';
  };

  return (
    <Box sx={{ mb: 0.75 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.25 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <BoltIcon sx={{ fontSize: 12, color: getEnergyColor() }} />
          <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.55rem', fontWeight: 600 }}>
            Энергия
          </Typography>
        </Box>
        <Typography
          variant="caption"
          sx={{
            fontSize: '0.55rem',
            fontWeight: 700,
            color: isStale ? 'text.disabled' : getEnergyColor(),
          }}
        >
          {Math.round(safeCurrent)}/{Math.round(safeMax)}
          {safeFatigue > 0 && (
            <Box component="span" sx={{ color: 'text.secondary', ml: 0.5 }}>
              (уст. {Math.round(safeFatigue)})
            </Box>
          )}
        </Typography>
      </Box>

      <Tooltip
        title={
          safeFatigue > 0
            ? `Энергия: ${Math.round(safeCurrent)}/${Math.round(safeMax)} • Усталость: ${Math.round(safeFatigue)}`
            : `Энергия: ${Math.round(safeCurrent)}/${Math.round(safeMax)}`
        }
        arrow
        placement="top"
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: 4,
            borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.08)',
            overflow: 'hidden',
            opacity: isStale ? 0.5 : 1,
            transition: 'opacity 0.3s ease',
          }}
        >
          {/* Синяя зона — текущая энергия */}
          <Box
            sx={{
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              width: `${currentPct}%`,
              bgcolor: getEnergyColor(),
              transition: 'width 0.6s ease, background-color 0.3s ease',
            }}
          />
          {/* Серая зона — усталость (перекрывает справа) */}
          {safeFatigue > 0 && (
            <Box
              sx={{
                position: 'absolute',
                left: `${currentPct}%`,
                top: 0,
                bottom: 0,
                width: `${Math.min(fatiguePct, 100 - currentPct)}%`,
                bgcolor: '#6b7280',
                opacity: 0.6,
                transition: 'width 0.6s ease, left 0.6s ease',
                backgroundImage:
                  'repeating-linear-gradient(45deg, transparent, transparent 2px, rgba(0,0,0,0.2) 2px, rgba(0,0,0,0.2) 4px)',
              }}
            />
          )}
        </Box>
      </Tooltip>
    </Box>
  );
};

export default EnergyBar;
